import css from 'styled-jsx/css'
import common from './common'


export default css.global`

  #tarteaucitronRoot {
    --cl-lightBlue: #41487C;
    --cl-darkBlue: #131A4C;
    --cl-yellow: #FFBB00;
    --cl-lighGrey: #E7E8ED;
  }
  /* BOTTOM BAR */

  #tarteaucitronRoot {
    ${common.h7}
    color: black;
  }

  #tarteaucitronRoot > #tarteaucitronAlertBig {
    background-color: var(--cl-lightBlue) !important;
  }

  #tarteaucitronRoot > #tarteaucitronAlertBig > button {
    ${common.h7}
    margin: 5px;
  }

  #tarteaucitronRoot > #tarteaucitronAlertBig > #tarteaucitronDisclaimerAlert {
    ${common.h7}
  }

  #tarteaucitronRoot > #tarteaucitronAlertBig > .tarteaucitronAllow {
    background-color: var(--cl-yellow) !important;
    color: black;
  }

  #tarteaucitronRoot > #tarteaucitronAlertBig > .tarteaucitronDeny,#tarteaucitronRoot > #tarteaucitronAlertBig > #tarteaucitronCloseAlert  {
    background-color: var(--cl-darkBlue) !important;
    color: white !important;
  }

  /* MODAL OPEN */

  #tarteaucitronRoot .tarteaucitronSelfLink {
    display: none;
  }

  #tarteaucitronRoot button {
    ${common.h7}
  }

  #tarteaucitronRoot #tarteaucitronClosePanel {
    background-color: var(--cl-lightBlue) !important;
  }

  #tarteaucitronRoot #tarteaucitronServices .tarteaucitronLine {
    background-color: var(--cl-lighGrey) !important;
  }

  #tarteaucitronRoot .tarteaucitronH3 {
    color: black !important;
  }

  #tarteaucitronRoot #tarteaucitronServicesTitle_analytic {
    background-color: transparent !important;
  }

  #tarteaucitronRoot #tarteaucitronServices_analytic {
    background-color: var(--cl-lighGrey) !important;
  }
  
  #tarteaucitronRoot #tarteaucitronDetailsanalytic {
    background-color: transparent !important;
    color: black !important;
  }

  #tarteaucitronRoot #tarteaucitronSave {
    background-color: var(--cl-lightBlue) !important;
  }

  #tarteaucitronRoot #tarteaucitronSaveButton {
    background-color: var(--cl-yellow) !important;
  } 

  #tarteaucitronRoot .asCatToggleBtn {
    background-color: var(--cl-lightBlue) !important;
  }
  

  #tarteaucitronRoot button::before, #tarteaucitronRoot span::before {
    content: none;
    display: none !important;
  }

  #tarteaucitronRoot button#tarteaucitronBack {
    background-color: rgba(0,0,0, .5) !important;
  }

  #tarteaucitronRoot #tarteaucitronServices {
    box-shadow: none;
  }

  #tarteaucitron #tarteaucitronServices .tarteaucitronMainLine, #tarteaucitron #tarteaucitronInfo {
    background-color: var(--cl-lightBlue) !important;
    border: none !important;
  }

  #tarteaucitronRoot .tarteaucitronAllow.tarteaucitronIsSelected, #tarteaucitronRoot .tarteaucitronIsAllowed button.tarteaucitronAllow {
    background-color: var(--cl-yellow) !important;
  }
  
  #tarteaucitronRoot .tarteaucitronDeny.tarteaucitronIsSelected, #tarteaucitronRoot .tarteaucitronIsDenied button.tarteaucitronDeny {
    background-color: var(--cl-darkBlue) !important;
    color: white !important;
  }

  #tarteaucitronRoot .tarteaucitronAllow, #tarteaucitronRoot .tarteaucitronIsAllowed button {
    opacity: 1 !important;
    background-color: white !important;
    color: black !important;
  }
  
  #tarteaucitronRoot .tarteaucitronDeny, #tarteaucitronRoot .tarteaucitronIsDenied button {
    opacity: 1 !important;
    background-color: white !important;
    color: black !important;
  }
`
